import { getCurrentRankConfig, parseRankStringToLevelSublevel } from './rank-helpers';
import { cfgToThemeCdnPath, FeatureSet, stateFeatureSet } from '@infinitro/config';
import { get } from 'svelte/store';
/**
 * Build badge image path from level 1–11 and sublevel 0–5.
 * When sublevelImages is true: /badges/{levelNum}.{sublevel}.png for sublevel > 0, else /badges/{levelNum}.png.
 * When false or undefined: always /badges/{levelNum}.png (one image per level).
 *
 * In FeatureSet.Preview, resolves under badges/staging first (same mechanism as game
 * tiles in `card.svelte`'s getTileSources) so in-progress badge art can be previewed
 * before being promoted to the production CDN path.
 */
export const getBadgeImagePath = (levelNum, sublevel, sublevelImages) => {
    const useSublevel = sublevelImages === true && sublevel > 0;
    const file = useSublevel ? `${levelNum}.${sublevel}.png` : `${levelNum}.png`;
    const stagePath = get(stateFeatureSet) === FeatureSet.Preview ? '/staging' : '';
    return cfgToThemeCdnPath(`/badges${stagePath}/${file}`);
};
/** Resolve rank (number = level index, string = rank name or "level.sub") to level index 1–11. */
function levelNumFromRank(rank) {
    if (rank == null)
        return undefined;
    if (typeof rank === 'string' && rank.trim() === '')
        return undefined;
    if (typeof rank === 'number') {
        const n = Math.round(rank);
        return n >= 1 && n <= 11 ? n : undefined;
    }
    const { levelIndex } = parseRankStringToLevelSublevel(rank);
    return levelIndex >= 1 && levelIndex <= 11 ? levelIndex : undefined;
}
export const getRankIconInfo = (rank, level) => {
    const levelNum = levelNumFromRank(rank);
    const sublevel = level != null ? Math.min(5, Math.max(0, Math.round(level))) : 0;
    const rankName = levelNum != null
        ? `Rank ${levelNum}`
        : `Rank ${parseRankStringToLevelSublevel(rank).levelIndex}`;
    const config = getCurrentRankConfig();
    const imageSrc = levelNum != null ? getBadgeImagePath(levelNum, sublevel, config.sublevelImages) : undefined;
    return {
        rankName,
        imageSrc
    };
};
